export enum MessageTopicEnum {
  SERVER_ENCRYPTION_KEY = 'server_encryption_key',
  SERVER_DECRYPTION_KEY = 'server_decryption_key',
  KEY_REQUEST = 'key_request',
}
